import { Input, Button, Form, Checkbox, Select, Radio, RadioChangeEvent } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addNut, modifyNut } from "./NutSlice";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/store/rootReducer";

export default function AddNut(): JSX.Element {
  const dispatch = useDispatch();
  const MaterialsData = useSelector((state: AppState) => state.NutMaterials);
  const ShapesData = useSelector((state: AppState) => state.NutShapes);
  const { setModelChange, messageApi, editBodySize, setEditBodySize } =
    React.useContext(CommonContext) as CommonContextType;
  const [form] = Form.useForm();
  const [material_array, setMaterialArray] = useState([{}]);
  const [shape_array, setShapeArray] = useState([{}]);
  React.useEffect(() => {
    if (MaterialsData.NutMaterial.length > 0) {
      const arr = MaterialsData.NutMaterial.map((el: any) => ({ value: el.id, label: el.material_name }))
      setMaterialArray(arr);
    }

    if (ShapesData.NutShape.length > 0) {
      const arr = ShapesData.NutShape.map((el: any) => ({ value: el.id, label: el.shape_name }))
      setShapeArray(arr);
    }
    if (editBodySize?.id) {
      // form.setFieldsValue(editBodySize);
      form.setFieldsValue(Object.assign({ nut_materials: editBodySize?.nut_material?.id }, { nut_shapes: editBodySize?.nut_shape?.id },editBodySize))
    }
    else {
      form.resetFields();
    }
  }, [editBodySize, form]);

  const onFinish = (values: any) => {
    values.nut_material = values.nut_materials
    values.nut_shape = values.nut_shapes
    delete(values.nut_materials)
    delete(values.nut_shapes)
    if (editBodySize?.id) {
      values.updated_datetime = new Date().toLocaleString() + "";
      dispatch(modifyNut(values, editBodySize?.id));
    /*   messageApi.open({
        type: "success",
        content: "Nut Updated successfully",
      }); */
    } else {
      values.created_datetime = new Date().toLocaleString() + "";
      dispatch(addNut(values));
    }
    setModelChange(false);
    setEditBodySize(null);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const onChange = (e: CheckboxChangeEvent) => {
    // console.log(`checked = ${e.target.checked}`);
  };
  const onChangeSelect = (e: RadioChangeEvent) => {
    console.log("radio", e.target.value)
  }
  return (
    <Form
      form={form}
      layout={"vertical"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      initialValues={{
        default_sts: false,
      }}
    >
      <Form.Item
        label="Nut Name"
        name="nut_name"
        rules={[
          {
            required: true,
            message: "Please enter Nut name",
          }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Nut Material"
        name="nut_materials"
        rules={[
          {
            required: true,
            message: "Please select Nut material",
          }
        ]}
      >
        <Select
          // style={{ width: 120 }}
          options={material_array}
        />
      </Form.Item>

      <Form.Item
        label="Nut Shape"
        name="nut_shapes"
        rules={[
          {
            required: true,
            message: "Please enter Nut Shape",
          }
        ]}
      >
        <Select
          // style={{ width: 120 }}
          options={shape_array}
        />
      </Form.Item>

      <Form.Item
                name='status'>
                <Radio.Group onChange={onChangeSelect}>
                    <Radio value="Released">Released</Radio>
                    <Radio value="Not Released">Not Released</Radio>
                    <Radio value="Under Construction">Under Construction</Radio>
                </Radio.Group>
            </Form.Item>

      <Form.Item
        name='default_sts' valuePropName="checked">
        <Checkbox onChange={onChange}>default</Checkbox>
      </Form.Item>

      <Form.Item>
        <Button style={{ backgroundColor: '#018B98', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} type="primary" htmlType="submit" >{editBodySize?.id ? 'Update' : 'Create'}</Button>
      </Form.Item>
    </Form>
  );
}
